module.exports = __webpack_public_path__ + "static/goodnight-moon-c5e6bcb92d903c892685b0c91137f236.jpg";